import React from 'react';
import About from './About';
import Contact from './Contact';
import Featured from './Featured';
import Footer from './Footer';

const Home = ({ cover, allItems }) => {
    document.title = 'SIHAH - Home';

    return (
        <>
        <img src={cover.url} alt="SIHAH Header" width="100%" />
        <Featured allItems={allItems} />
        <About />
        <Contact />
        <Footer />
        </>
    );
};

export default Home;